import React from 'react'

import { IS_ASSESSMENT_REVAMP_ENABLED } from 'configs/toggle'
import AssessmentApp from 'app/AssessmentPage'

export async function getServerSideProps() {
  if (!IS_ASSESSMENT_REVAMP_ENABLED) {
    return {
      redirect: {
        destination: '/assessment/litnum',
        permanent: false,
      },
    }
  }
  return {
    props: {},
  }
}

const AssessmentPage = () => {
  return (
    <>
      <AssessmentApp />
    </>
  )
}

export default AssessmentPage
